import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Location } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-validate-essentials-modal',
  templateUrl: './validate-essentials-modal.component.html',
  styleUrls: ['./validate-essentials-modal.component.scss'],
})
export class ValidateEssentialsModalComponent implements OnInit {
  dataRecieved: any;
  readonly modals = [
    {
      cssClass: null,
      img: '⚠️',
      title: 'Algo salió mal con tus productos infaltables',
      description: 'Inténtalo nuevamente en unos minutos.',
      actions: [
        {
          name: 'Entendido',
          class: 'btn-red-new',
          event: () => {
            this.dialogRef.close(true);
          },
        },
      ],
    },
    {
      cssClass: null,
      img: '☝️',
      title: '¡Ups! Algunos infaltables ya no están disponibles',
      description:
        'Retiramos los productos que ya no están disponibles. Échale un vistazo a los nuevos infaltables de este mes.',
      actions: [
        {
          name: 'Entendido',
          class: 'btn-red-new',
          event: () => {
            this.dialogRef.close(true);
          },
        },
      ],
    },
  ];
  readonly displayedColumns: string[] = ['sku', 'description'];
  constructor(
    public readonly dialogRef: MatDialogRef<ValidateEssentialsModalComponent>,
    private readonly location: Location,
    private readonly renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.dataRecieved = data;
  }

  ngOnInit(): void {
    this.openedStart();
  }

  ngOnDestroy(): void {
    this.closedStart();
  }

  closeDialog(event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.closedStart();
    this.dialogRef.close(false);
  }    

  openedStart() {
    this.renderer.addClass(document.body, 'modal-open');
  }

  closedStart() {
    this.renderer.removeClass(document.body, 'modal-open');
  }
}
